import { Instagram, Facebook, Mail, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-border/50 bg-secondary/20 w-full overflow-x-hidden">
      <div className="container mx-auto px-4 sm:px-6 py-8 sm:py-12 w-full">
        <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 w-full">
          {/* Brand */}
          <div className="space-y-4 sm:col-span-2 md:col-span-1">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                <img 
                  src="/gabi.png" 
                  alt="GABI" 
                  className="w-full h-full object-contain"
                />
              </div>
              <span className="text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-primary to-accent">
                GABI IA
              </span>
            </div>
            <p className="text-sm text-muted-foreground break-words">
              Hecho por personas que también se perdieron buscando piso. 💜 Habily. Claridad para tu primera vivienda.
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="font-semibold mb-4">Producto</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link to="/chat" className="hover:text-primary transition-colors">
                  Chat con IA
                </Link>
              </li>
              <li>
                <Link to="/analyzer" className="hover:text-primary transition-colors">
                  Generador de Informes
                </Link>
              </li>
              <li>
                <Link to={{ pathname: "/", hash: "features" }} className="hover:text-primary transition-colors">
                  Características
                </Link>
              </li>
              <li>
                <Link to={{ pathname: "/", hash: "how-it-works" }} className="hover:text-primary transition-colors">
                  Cómo funciona
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold mb-4">Empresa</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link to={{ pathname: "/", hash: "sobre-nosotros" }} className="hover:text-primary transition-colors">
                  Sobre nosotros
                </Link>
              </li>
              <li>
                <Link to="/blog" className="hover:text-primary transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="hover:text-primary transition-colors">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold mb-4">Legal</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link to="/privacidad" className="hover:text-primary transition-colors">
                  Privacidad
                </Link>
              </li>
              <li>
                <Link to="/terminos" className="hover:text-primary transition-colors">
                  Términos
                </Link>
              </li>
              <li>
                <Link
                  to={{ pathname: "/cookies", hash: "panel-configuracion-cookies" }}
                  className="hover:text-primary transition-colors"
                >
                  Cookies
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border/50 mt-8 sm:mt-12 pt-6 sm:pt-8 flex flex-col md:flex-row items-center justify-between gap-6 w-full">
          <div className="flex flex-col items-center md:items-start gap-3 max-w-xl">
            <p className="text-sm text-muted-foreground break-words text-center md:text-left">
              © {currentYear} GABI IA. Todos los derechos reservados.
            </p>
            <p className="flex items-start gap-2 text-sm text-muted-foreground text-center md:text-left">
              <MapPin className="w-4 h-4 shrink-0 mt-0.5 text-primary" aria-hidden />
              <span>
                Avenida Republica Argentina, 25, plata 9. 41011 Sevilla
              </span>
            </p>
          </div>

          <div className="flex items-center gap-4">
            <a 
              href="https://mail.google.com/mail/?view=cm&fs=1&to=info@habily.es"
              target="_blank"
              rel="noopener noreferrer"
              className="w-9 h-9 rounded-full bg-secondary hover:bg-primary/10 flex items-center justify-center transition-colors hover:scale-110"
              aria-label="Enviar email a Habily"
            >
              <Mail className="w-4 h-4 text-foreground hover:text-primary" />
            </a>
            <a 
              href="https://www.instagram.com/habily_homes/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-9 h-9 rounded-full bg-secondary hover:bg-primary/10 flex items-center justify-center transition-colors hover:scale-110"
              aria-label="Instagram de Habily"
            >
              <Instagram className="w-4 h-4 text-foreground hover:text-primary" />
            </a>
            <a 
              href="https://www.tiktok.com/@habily.es" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-9 h-9 rounded-full bg-secondary hover:bg-primary/10 flex items-center justify-center transition-colors hover:scale-110"
              aria-label="TikTok de Habily"
            >
              <svg 
                className="w-4 h-4 text-foreground hover:text-primary" 
                viewBox="0 0 24 24" 
                fill="currentColor"
              >
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.89 2.89 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
              </svg>
            </a>
            <a 
              href="https://www.facebook.com/p/Habily-61561583143005/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-9 h-9 rounded-full bg-secondary hover:bg-primary/10 flex items-center justify-center transition-colors hover:scale-110"
              aria-label="Facebook de Habily"
            >
              <Facebook className="w-4 h-4 text-foreground hover:text-primary" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
